import React, { useEffect } from "react";
import "rsuite/dist/rsuite.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./global.scss";
import "./custom.scss";
import "./fonts.css";
import "./responsive.scss";
import { Route, Routes, useNavigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes";
import AuthMiddleware from "./routes/route";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useDispatch, useSelector } from "react-redux";
import Toast from "./components/common/Toast";
import { checkVerificationStatus } from "store/actions/authSlice";
function App() {
  const { isVisible, text, type } = useSelector((state) => state.Alert);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = !!localStorage.getItem("authUser");
  useEffect(() => {
    if (isAuthenticated) {
      const userId = localStorage.getItem('authUserId');

      dispatch(checkVerificationStatus({ userId }))
        .then((action) => {
          const { statusCode, success, message, data } = action?.payload || {};
          if (statusCode === 200 && success) {
            console.log("Varification Data is" , data);
            // dispatch(showAlert({ text: message, type: "success" }));
            const { hasSubscriptionEntry, isCompanyDetailsSaved } = data || {};

            if (!hasSubscriptionEntry) {
              navigate("/plan-picker");
            }else if(!isCompanyDetailsSaved){
              navigate("/orgnisation-details");              
            }else{
              return true;
            }
            // setIsEmailVerified(true);
          }
        })
        .catch((err) => { });
    }
  }, [])

  return (
    <React.Fragment>
      {isVisible && <Toast isVisible={isVisible} text={text} type={type} />}

      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}

        {/* Auth Protected Routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<AuthMiddleware>{route.element}</AuthMiddleware>}
            key={idx}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
